import { Component, Input } from '@angular/core';
import { ButtonComponent } from '../../button/component/button.component';
import { Button } from '../../button/models/button.models';

@Component({
  selector: 'app-card',
  standalone: true,
  imports: [ButtonComponent],
  templateUrl: './card.component.html',
  styleUrl: './card.component.scss',
})
export class CardComponent {
  @Input() title: string = '';
  @Input() description: string = '';
  @Input() button!: Button;
}
